import { render, staticRenderFns } from "./EditRetailerChain.vue?vue&type=template&id=fda9a668&scoped=true&"
import script from "./EditRetailerChain.vue?vue&type=script&lang=js&"
export * from "./EditRetailerChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9a668",
  null
  
)

export default component.exports